import React from "react"
import styled, { createGlobalStyle, ThemeProvider } from "styled-components"
import useDarkMode from 'use-dark-mode';
import Header from "./layout/header"
import SideBar from "./layout/sidebar"

import "../utils/normalize.css"

import media from "../utils/mediaQueries"
import {themeLight, themeDark} from '../utils/themes'
import MobileMenuToggle from "./layout/mobilemenutoggle";
import useToggle from "../utils/hooks/useToggle";

const { se, desktop, largeDesktop, massive } = media


const Layout = ({ children }) => {
  const darkMode = useDarkMode(false);

  const [isToggled, toggle] = useToggle(false)

  return (
    <ThemeProvider theme={darkMode.value ? themeDark : themeLight}>
      <>
      <PageWrapper>
        <Header />
        <StyledMain>
          <StyledMainContainer>
            <SideBar toggleOpen={isToggled} />
            <ContentArea>{children}</ContentArea>
          </StyledMainContainer>
        </StyledMain>
        <MobileMenuToggle isClicked={isToggled} toggle={toggle} />
      </PageWrapper>
      </>
    </ThemeProvider>
  )
}

export default Layout

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  overflow-y: scroll;

  ${desktop && desktop`
  height: 100vh;
  `}
`

const StyledMain = styled.main`
  ${desktop &&
    desktop`
  display: flex;
  flex: 1 1 0%;
`}
`

const StyledMainContainer = styled.div`
  
  ${desktop &&
    desktop`
  display: flex;
  width: 100%;
`}
`

const ContentArea = styled.div`
  background-color:${props => (props.theme.bg)};
  height: max-content;
  
  ${se && se`
    padding: 20px;
  `}

  ${desktop &&
    desktop`
    margin-left: 330px
    width: 100%;
    display: flex;
    padding: 20px;
    padding-top: 90px;
    flex-direction: column;
  `}

  ${largeDesktop && largeDesktop`
    padding: 80px 30px 30px 30px;
  `}

  ${massive && massive`
    padding: 80px 40px 40px 40px;
  `}
`

const GlobalStyle = createGlobalStyle`
 body {
   font-family: 'Open Sans', san-serif;
 }
`